module.exports = "/_next/static/images/5e4306aa297ed1c334838d16160277ff-digital-account-phone-main-screen@xs-1x.png";